import axios from 'axios';
import { Aerator } from 'views/production-systems/features/farm-setup/types/aerators.type';
import { UpdateAssignedAeratorsInput } from 'views/production-systems/features/farm-setup/types/update-aerators-input.type';

// POST AeratorToPond
// /ewosapi/v1/shrimps/aerator/registration?globalSiteId={globalSiteId}
export const putAerators = async (globalSiteId: string, request: UpdateAssignedAeratorsInput) => {
  const res = await axios.post<Aerator>(`/ewosapi/v1/shrimps/aerator/registration?globalSiteId=${globalSiteId}`, request);
  return res.data;
};
